import React from 'react'
import clsx from 'clsx'
import Icon from '../Icon/Icon'

export const InputText = ({
  otherClasses,
  placeholder,
  onChange,
  value,
  name,
  min,
  max,
  required,
  pattern,
  warning,
  label,
  labelClasses,
  iconClasses,
  id,
  type,
}) => {
  const inputTextClasses = clsx(
    otherClasses,
    'w-full placeholder:text-[#C6C6C8] hover:bg-primary_blue_50 text-[20px] leading-[30px] font-normal font-work-sans text-primary_heading_color  border-[1px] px-4 py-[13px]  rounded-full placeholder:font-work-sans  placeholder:text-[20px] placeholder:leading-[30px] placeholder:font-normal  ',
    warning
      ? 'border-[#ff4444] placeholder:text-[#ff4444] focus:outline-[2px] active:border-[1px] active:outline-0 caret-[#ff4444] active:border-[#ff4444] focus:border-transparent focus:outline focus:outline-[#ff4444]'
      : 'border-gray-500 focus:outline-[2px] placeholder:text-primary_heading_color active:border-[1px] active:outline-0 caret-[#2D7CF1] active:border-gray-500 focus:border-transparent focus:outline focus:outline-primary_dark_blue_500'
  )

  return (
    <div className="flex flex-col gap-6 relative ">
      {label && (
        <label
          htmlFor={label}
          className={clsx(
            labelClasses,
            'font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]'
          )}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      {warning && (
        <div
          className={clsx(
            iconClasses,
            'mr-4 absolute right-0 top-[73%] translate-y-[-50%]'
          )}
        >
          <Icon icon="warning-red-icon" iconHeight={24} iconWidth={24} />
        </div>
      )}
      <input
        name={name}
        id={id}
        pattern={pattern}
        min={min}
        max={max}
        type={type}
        value={value}
        required={required}
        onChange={(e) => onChange(e, id)}
        placeholder={placeholder}
        className={inputTextClasses}
        data-testid="input-text"
      />
    </div>
  )
}

export default InputText
